import { DeleteOutlined, TranslationOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { type ReactNode } from 'react';
import styled from 'styled-components';
import MarkdownField, { type MarkdownFieldProps } from './MarkdownField';
import { type TranslationDrawerProps, useTranslationDrawer } from './TranslatedInputField/TranslationDrawer';

export type TranslatedMarkdownFieldProps = MarkdownFieldProps &
    Pick<TranslationDrawerProps, 'languages'> & { addMoreButton?: ReactNode; disabled?: boolean };

export const StyledButtonContainer = styled.div`
    background: #fafafa;
    border-top: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
    border-right: 1px solid #d9d9d9;
    padding: 0px 10px;
`;
const TranslatedMarkdownField = ({
    name,
    languages,
    disabled,
    addMoreButton,
    withContentRefinement,
    ...props
}: TranslatedMarkdownFieldProps) => {
    const drawer = useTranslationDrawer();

    const button = disabled ? null : (
        <StyledButtonContainer>
            <Button
                disabled={disabled}
                icon={<TranslationOutlined style={{ color: 'var(--ant-primary-color)' }} />}
                onClick={drawer.open}
                size="small"
                style={{ height: '100%' }}
                type="text"
            />
            {addMoreButton}
        </StyledButtonContainer>
    );

    const renderMarkdownField: TranslationDrawerProps['renderField'] = (translation, onDelete) => {
        const button = (
            <StyledButtonContainer>
                <Button
                    icon={<DeleteOutlined />}
                    onClick={onDelete}
                    size="small"
                    style={{ height: '100%' }}
                    type="text"
                />
            </StyledButtonContainer>
        );

        return (
            <MarkdownField
                key={translation.languagePackId}
                addMoreButton={button}
                label={translation.language.referenceName}
                name={translation.name}
                required={false}
                withContentRefinement={withContentRefinement}
            />
        );
    };

    return (
        <>
            <MarkdownField
                {...props}
                addMoreButton={button}
                disabled={disabled}
                name={`${name}.defaultValue`}
                withContentRefinement={withContentRefinement}
            />
            {drawer.render({
                name,
                title: props.label,
                languages,
                renderField: renderMarkdownField,
            })}
        </>
    );
};

export default TranslatedMarkdownField;
